export default "__VITE_ASSET__CxT0wl1S__"